<template>
  <transition name="fade">
    <div class="wrapper">
      <div class="inn">
        <!--<div class="img" :style="{backgroundImage: 'url('+url+'?_'+Date.now()+')'}" v-if="type == 'gif'"></div>
        <div class="img" :style="{backgroundImage: 'url('+url+')'}" v-if="type == 'img'"></div>-->
        <img
          v-if="type == 'gif'"
          :src="url + '?_' + Date.now()"
          :style="{ width: wid, height: hig }"
        />
        <img
          v-if="type == 'img'"
          :src="url"
          :style="{ width: wid, height: hig }"
        />
        <video v-if="type == 'video'" :src="url" controls></video>
        <div class="close" @click="close">
          <img v-show="url.length > 0" src="../../assets/cloe.png" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      maxW: window.screen.width,
      maxH: window.screen.height,
      wid: "auto",
      hig: "auto"
    };
  },
  props: {
    url: String,
    type: String
  },
  created() {
    var img_url = this.url;
    var img = new Image();
    img.src = img_url;
    if (img.height > img.width) {
      this.hig = this.maxH * 0.8 + "px";
      this.wid = Math.ceil((img.width / img.height) * this.maxH * 0.8) + "px";
    } else {
      if (window.screen.width / window.screen.height > 1.744) {
        this.wid = this.maxW * 0.62 + "px";
        this.hig =
          Math.ceil((img.height / img.width) * this.maxW * 0.62) + "px";
      } else {
        this.wid = this.maxW * 0.58 + "px";
        this.hig =
          Math.ceil((img.height / img.width) * this.maxW * 0.58) + "px";
      }
    }
  },
  mounted() {},
  methods: {
    close() {
      this.$emit("accept");
    }
  },
  computed: {}
};
</script>

<style lang="scss" scoped>
.wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  opacity: 1;
  height: 100vh;
  overflow-y: auto;

  .inn {
    display: inline-block;
    position: relative;
    margin-top: 30px;

    img,
    video {
      width: 100%;
    }

    .img {
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;
    }

    .close {
      position: absolute;
      right: -28px;
      top: -28px;
      width: 58x;
      height: 58px;
      cursor: pointer;

      img {
        width: 100%;
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/package/bImg.vue